import React from "react";
import { useAlert } from "../../contexts/AlertContext";
import GlobalStyles from "../../global/GlobalStyle";

const AlertContainer: React.FC = () => {
  const alertContext = useAlert();
  const { alerts } = alertContext;

  const hideAlert = (id: any) => {
    if (typeof (alertContext as any).hideAlert === "function") {
      (alertContext as any).hideAlert(id);
    } else if (typeof (alertContext as any).removeAlert === "function") {
      (alertContext as any).removeAlert(id);
    } else if (typeof (alertContext as any).dismiss === "function") {
      (alertContext as any).dismiss(id);
    } else {
      // no-op if no matching function is available on the context
    }
  };

  if (alerts.length === 0) return null;

  const getAlertStyle = (type: string) => {
    switch (type) {
      case "success":
        return GlobalStyles.alertSuccess;
      case "error":
        return GlobalStyles.alertError;
      case "warning":
        return GlobalStyles.alertWarning;
      case "info":
        return GlobalStyles.alertInfo;
      default:
        return "";
    }
  };

  const getAlertIcon = (type: string) => {
    switch (type) {
      case "success":
        return "✅";
      case "error":
        return "❌";
      case "warning":
        return "⚠️";
      case "info":
        return "ℹ️";
      default:
        return "";
    }
  };

  return (
    <div className="fixed top-20 right-5 z-50 space-y-2 max-w-sm">
      {alerts.map((alert) => (
        <div
          key={alert.id}
          className={`${GlobalStyles.alert} ${getAlertStyle(
            alert.type
          )} transform transition-all duration-300 ease-in-out animate-in slide-in-from-right-full`}
        >
          <div className="flex items-center gap-3">
            <span className="text-sm">{getAlertIcon(alert.type)}</span>
            <span className="text-sm flex-1">{alert.message}</span>
            <button
              onClick={() => hideAlert(alert.id)}
              className="text-gray-500 hover:text-gray-700 transition-colors"
            >
              ✕
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default AlertContainer;
